"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
/**
 * A utility for checking for shopping cart and list support.
 */
var ShoppingSupport = /** @class */ (function () {
    function ShoppingSupport() {
    }
    /**
     * Checks if shopping cart is supported.
     *
     * @param localizedInformation Localized information.
     * @returns Returns "true" if shopping cart is supported.
     */
    ShoppingSupport.hasCartSupport = function (localizedInformation) {
        var eCommerceCartDataSource = localizedInformation.localization.eCommerceCartDataSource;
        var shopOnlineEnabled = localizedInformation.localization.shopOnlineEnabled;
        switch (eCommerceCartDataSource) {
            case enums_1.EcommerceCartDataSourceEnum.disabled:
                return false;
            case enums_1.EcommerceCartDataSourceEnum.default:
                return shopOnlineEnabled === true;
        }
        return true;
    };
    /**
     * Checks if shopping list is supported.
     *
     * @param localizedInformation Localized information.
     * @returns Returns "true" if shopping list is supported.
     */
    ShoppingSupport.hasListSupport = function (localizedInformation) {
        var apiPlatform = localizedInformation.localization.apiPlatform;
        var eCommerceShoppingListDataSource = localizedInformation.localization.eCommerceShoppingListDataSource;
        var eCommerceCartDataSource = localizedInformation.localization.eCommerceCartDataSource;
        switch (eCommerceShoppingListDataSource) {
            case enums_1.EcommerceShoppingListDataSourceEnum.shoppingListApi:
            case enums_1.EcommerceShoppingListDataSourceEnum.chinaShoppingListApi:
            case enums_1.EcommerceShoppingListDataSourceEnum.iows:
                return true;
            case enums_1.EcommerceShoppingListDataSourceEnum.default:
                switch (eCommerceCartDataSource) {
                    case enums_1.EcommerceCartDataSourceEnum.iows:
                    case enums_1.EcommerceCartDataSourceEnum.cartApi:
                        return true;
                    case enums_1.EcommerceCartDataSourceEnum.default:
                        switch (apiPlatform) {
                            case enums_1.ApiPlatformEnum.irw:
                                return true;
                        }
                }
        }
        return false;
    };
    return ShoppingSupport;
}());
exports.default = ShoppingSupport;
//# sourceMappingURL=ShoppingSupport.js.map